export default __webpack_public_path__ + "static/media/icon-hide.087571e2.svg";